


















































import {
  Component,
  Mixins,
  Prop,
  Vue,
  Watch,
  Ref,
} from 'vue-property-decorator'
import PagedMixin from '@/common/pagination/mixins/paged-mixin'
import Judge from '@/evaluations/entities/judge'

@Component
export default class JudgesTable extends Mixins(PagedMixin) {
  @Prop({ type: Boolean, default: false })
  public loading!: boolean

  @Prop({ default: () => [] })
  public items!: Judge[]

  @Prop({ type: Boolean, default: false })
  public disabled!: boolean

  @Prop({type: Boolean, default: false })
  public showSend!: boolean

  @Watch('items')
  private itemsChanged() {}

  private click() {}

  private get headers() {
    return [
      {
        text: this.$tc('common.email.singular'),
        value: 'email',
        sortable: false,
        width: '25%',
      },
      {
        text: this.$tc('common.name.full'),
        value: 'name',
        sortable: false,
        width: '25%',
      },
      {
        text: '',
        value: 'action',
        sortable: false,
        cellClass: 'table-actions',
        align: 'end',
      },
    ]
  }
}
